// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  #analytic_dashboard.e-dashboardlayout.e-control .e-panel .e-panel-container .e-panel-header {
    border-bottom: 2px solid #e6e9ed !important;
    height: 35px;
    padding: 0 15px 0 15px;
    line-height: 35px;
  }

 #analytic_dashboard .card-content.text {
    font-size: 15px;
    text-align: right;
    color: #66696b;
}
#analytic_dashboard .card-content.number {
    font-size: 16px;
    text-align: right;
    padding-top: 10px;
    font-weight: bold;
}

  #dockSideDash .fabric-dark .card-content.text{
    color: #dadada
  }

  @media (max-width: 650px) {
    .e-bigger .searchContent {
      display: none;
    }
    .information{
        right:17% !important;
    }
  }



  #analytic_dashboard  {
  background: linear-gradient(-141deg, #eef5f7 14%, #eef2fb 100%);
}

#analytic_dashboard  .card .e-icons {
    position: absolute;
    top: 40%;
    left: 5%;
    width: 15%;
    text-align: center;
    border: 1px solid;
    line-height: 60px;
    color: #25c3cb;
    background: #eef5f7;
    border-radius: 60px;
    aspect-ratio : 1 / 1;
}

#analytic_dashboard .card {
    margin-right: 5%;
    margin-top: 5%;
  }
  #analytic_dashboard .e-icons svg {
    width: 70%;
    height: 70%;
    margin: 15%;
  }`, "",{"version":3,"sources":["webpack://./src/pages/CSS/dashboard.css"],"names":[],"mappings":";EACE;IACE,2CAA2C;IAC3C,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;EACnB;;CAED;IACG,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;AACrB;;EAEE;IACE;EACF;;EAEA;IACE;MACE,aAAa;IACf;IACA;QACI,oBAAoB;IACxB;EACF;;;;EAIA;EACA,+DAA+D;AACjE;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,UAAU;IACV,WAAW;IACX,WAAW;EACb","sourcesContent":["\r\n  #analytic_dashboard.e-dashboardlayout.e-control .e-panel .e-panel-container .e-panel-header {\r\n    border-bottom: 2px solid #e6e9ed !important;\r\n    height: 35px;\r\n    padding: 0 15px 0 15px;\r\n    line-height: 35px;\r\n  }\r\n\r\n #analytic_dashboard .card-content.text {\r\n    font-size: 15px;\r\n    text-align: right;\r\n    color: #66696b;\r\n}\r\n#analytic_dashboard .card-content.number {\r\n    font-size: 16px;\r\n    text-align: right;\r\n    padding-top: 10px;\r\n    font-weight: bold;\r\n}\r\n\r\n  #dockSideDash .fabric-dark .card-content.text{\r\n    color: #dadada\r\n  }\r\n\r\n  @media (max-width: 650px) {\r\n    .e-bigger .searchContent {\r\n      display: none;\r\n    }\r\n    .information{\r\n        right:17% !important;\r\n    }\r\n  }\r\n\r\n\r\n\r\n  #analytic_dashboard  {\r\n  background: linear-gradient(-141deg, #eef5f7 14%, #eef2fb 100%);\r\n}\r\n\r\n#analytic_dashboard  .card .e-icons {\r\n    position: absolute;\r\n    top: 40%;\r\n    left: 5%;\r\n    width: 15%;\r\n    text-align: center;\r\n    border: 1px solid;\r\n    line-height: 60px;\r\n    color: #25c3cb;\r\n    background: #eef5f7;\r\n    border-radius: 60px;\r\n    aspect-ratio : 1 / 1;\r\n}\r\n\r\n#analytic_dashboard .card {\r\n    margin-right: 5%;\r\n    margin-top: 5%;\r\n  }\r\n  #analytic_dashboard .e-icons svg {\r\n    width: 70%;\r\n    height: 70%;\r\n    margin: 15%;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
